<template>
    <div>
        <JobsOccupationsResume
            :jobs="value.perimeter_jobs"
            :occupations="value.perimeter_occupations"
            :displayWishes="false"
            :evaluatedOccupationSkills="value.occupations_skills"
            :display-collapses="true"
            :occupation-skills-goals="value.occupation_skills_goals"
            :jobColors="jobColors"
            :occupationColors="occupationColors"
        />

        <vs-row class="mt-10 p-5" style="background-color: rgba(0, 0, 0, 0.1);">
            <vs-col class="sm:w-1/5 w-full p-0">
                <span class="font-bold text-lg">Souhaits de la personne :</span>
            </vs-col>
            <vs-col class="sm:w-4/5 w-full"></vs-col>
        </vs-row>
        <div class="py-5 mt-1 ml-5">
            <vs-row class="mb-6 mt-10" >
                <vs-col class="sm:w-1/5 w-full">
                    <span>
                        Expérience(s) :
                    </span>
                </vs-col>
                <vs-col class="sm:w-4/5 w-full">
                    <Multiselect
                        id="wantedJobs"
                        v-model="resource.wishlist_jobs"
                        :options="jobs"
                        :multiple="true"
                        group-values="jobs"
                        group-label="establishmentService"
                        :group-select="true"
                        placeholder="Recherche ..."
                        track-by="uid"
                        label="title"
                        select-label=""
                        select-group-label=""
                        selected-label=""
                        deselect-label=""
                        deselect-group-label=""
                        :disabled="typeForm === 'validation' || typeForm === 'consultation'"
                    >
                        <span slot="noResult">Aucun résultat.</span>
                    </Multiselect>
                </vs-col>
            </vs-row>
            <vs-row class="mb-6">
                <vs-col class="sm:w-1/5 w-full">
                    <span>
                        Métier(s) :
                    </span>
                </vs-col>
                <vs-col class="sm:w-4/5 w-full">
                    <Multiselect
                        id="wantedOccupations"
                        v-model="resource.wishlist_occupations"
                        multiple
                        :options="occupations"
                        group-label="type"
                        group-values="occupations"
                        :group-select="false"
                        label="title"
                        :disabled="typeForm === 'validation' || typeForm === 'consultation'"
                        placeholder="Recherche ..."
                        track-by="uid"
                        select-label=""
                        select-group-label=""
                        selected-label=""
                        deselect-label=""
                        deselect-group-label=""
                        :loading="referentialOccupations.loading"
                    >
                        <span slot="noResult">Aucun résultat.</span>
                    </Multiselect>
                </vs-col>
            </vs-row>
        </div>

        <!-- Objectifs sur savoir-faire -->
        <OccupationSkillsGoal
            :occupation-skills="occupationSkillsAvailables"
            v-model="resource.occupation_skills_goals"
            :readonly="typeForm === 'consultation'"
            :themes="themes.data.filter(t => t != 'Compétence')"
            :states="states.data"
            :jobColors="jobColors"
            :occupationColors="occupationColors"
        />

        <!-- Objectifs sur compétences-->
        <SkillsGoal
            v-if="!occupationSkillRatingOnly"
            :skills="value.skills"
            v-model="resource.skills_goals"
            :readonly="typeForm === 'consultation'"
            :themes="themes.data.filter(t => t != 'Savoir-faire')"
            :states="states.data"
            :jobColors="jobColors"
            :occupationColors="occupationColors"
        />

        <!-- Autres objectifs -->
        <OthersGoal
            v-model="resource.others_goals"
            :readonly="typeForm === 'consultation'"
            :states="states.data"
            :themes="themes.data"
            :jobColors="jobColors"
            :occupationColors="occupationColors"
        />

        <!-------------  SYNTHESE  ------------->

        <vs-row class="mt-10 p-5" style="background-color: rgba(0, 0, 0, 0.1);">
            <vs-col class="sm:w-1/5 w-full p-0">
                <span class="font-bold text-lg">Synthèse du projet :</span>
            </vs-col>
            <vs-col class="sm:w-4/5 w-full"></vs-col>
        </vs-row>

        Liste des commentaires des évaluations et de l'auto-évaluation Portail
        <vs-row class="mt-20 mb-30">
            <vs-col v-for="(rating, i) in value.externals" :key="`external_${i}`" class="sm:w-1/2 w-full">
                <h3 class="mb-6 pl-5">Commentaires de
                    {{ rating.creator ? rating.creator.first_name : 'n/c' }}
                    {{ rating.creator ? rating.creator.last_name : 'n/c' }} :
                </h3>
                <vs-row>
                    <vs-col class="sm:w-4/5 w-full">
                        <div v-for="(comment, type) in rating.comment" :key="`external_type_${type}`">
                            <div><b>{{ getQuestionLabelFromSlug(type) }} :</b></div>
                            <div v-html="comment"></div>
                        </div>
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col v-for="(rating, i) in value.personals" :key="`personal_${i}`" class="sm:w-1/2 w-full">
                <h3 class="mb-6 pl-5">Commentaires de l'auto-évaluation :</h3>
                <vs-row>
                    <vs-col class="sm:w-4/5 w-full">
                        <div v-for="(comment, type) in rating.comment" :key="`external_type_${type}`">
                            <div><b>{{ getQuestionLabelFromSlug(type) }} :</b></div>
                            <div v-html="comment"></div>
                        </div>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>

        <!-- Saisie des commentaires de l'évaluation -->
        <template v-if="resource.comment || Object.values(resource.comment).length == 0">
            <vs-row v-for="ratingField in ratingFields" :key="ratingField.id" class="mb-20 mt-10">
                <vs-col class="sm:w-1/5 w-full">
                    <span class="font-bold text-lg"
                    >{{ ratingField.name }} :</span
                    >
                </vs-col>
                <vs-col class="sm:w-4/5 w-full">
                    <quill-editor
                        :value="resource.comment[ratingField.name]"
                        :name="'ratingField' + ratingField.id"
                        :options="options"
                        :disabled="typeForm === 'consultation'"
                        @input="debouncedInputHandleComment($event, ratingField.name)"
                    />
                </vs-col>
            </vs-row>
        </template>

        <template v-else>
            <vs-row v-for="(ratingFieldName, i) in Object.keys(resource.comment)" :key="`comment_${i}`" class="mb-20 mt-10">
                <vs-col class="sm:w-1/5 w-full">
                    <span class="font-bold text-lg"
                    >{{ ratingFieldName }} :</span
                    >
                </vs-col>
                <vs-col class="sm:w-4/5 w-full">
                    <quill-editor
                        :value="resource.comment[ratingFieldName]"
                        :name="'ratingField' + i"
                        :options="options"
                        :disabled="typeForm === 'consultation'"
                        @input="debouncedInputHandleComment($event, ratingFieldName)"
                    />
                </vs-col>
                
            </vs-row>
        </template>
    </div>
</template>

<script>
import JobsOccupationsResume from "../JobsOccupationsResume";
import ratingService from "@components/services/ratings";
import Multiselect from "vue-multiselect";
import OccupationSkillsGoal from "../OccupationSkillsGoal.vue";
import SkillsGoal from "../SkillsGoal.vue";
import OthersGoal from "../OthersGoal.vue";
import { quillEditor } from "vue-quill-editor";

export default {
    components: {
        Multiselect,
        JobsOccupationsResume,
        OccupationSkillsGoal,
        SkillsGoal,
        OthersGoal,
        quillEditor
    },
    props: {
        typeForm: {
            type: String,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        jobs: {
            type: Array,
            required: true
        },
        occupations: {
            type: Array,
            required: true
        },
        jobColors: {
            type: Array,
            required: true
        },
        occupationColors: {
            type: Array,
            required: true
        },
        states: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            log: console.log,
            resource: {
                wishlist_jobs: [],
                wishlist_occupations: [],
                occupation_skills_goals: [],
                skills_goals: [],
                others_goals: [],
                comment: {}
            },
            ratingFields: null,
            loading: true,
            referentialOccupations: {
                data: [],
                loading: true
            },
            themes: {
                data: [],
                loading: false
            },
            options: {
                placeholder: "...",
                modules: {
                    toolbar: [
                        [{ size: ["small", false, "large"] }],
                        ["bold", "italic", "underline"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link", "image"]
                    ]
                }
            },
            debouncedInputHandleComment: _.debounce((value, fieldName) => {
                this.inputHandleComment(value, fieldName);
            }, 800)
        };
    },
    created() {
        this.loadThemes();
        this.initResource();
        this.loadReferentialOccupations();

        if (this.typeForm == 'creation' && this.resource.wishlist_jobs.length == 0 && this.resource.wishlist_occupations.length == 0) {
            this.loadDefaultWishlist();
        }
        this.loadRatingFields();
    },
    computed: {
        occupationSkillRatingOnly() {
            return this.value.employee.occupation_skills_rating_only
        },
        // jobsWithoutGrids() {
        //     const jobTypes = window._.cloneDeep(this.jobs);

        //     return jobTypes.filter(o => o.establishmentService != 'Grilles');
        // },
        // occupationsWithoutGrids() {
        //     const occupationsTypes = window._.cloneDeep(this.occupations);

        //     return occupationsTypes.filter(o => o.type != 'Grilles');
        // },
        occupationsList() {
            const occupationsTypes = window._.cloneDeep(this.occupations);

            // TODO -
            // const centralOccupations = [
            //     ...occupationsTypes.find(o => o.type === 'Centralisé').occupations,
            //     ...this.referentialOccupations.data
            // ];

            // occupationsTypes.find(o => o.type === 'Centralisé').occupations = centralOccupations;

            return occupationsTypes;
        },
        occupationSkillsAvailables() {
            return this.value.occupations_skills.filter(os => os.is_deleted == false)
        },
    },
    watch: {
        resource: {
            handler: function(val) {
                this.inputHandle(val);
            },
            deep: true
        }
    },
    methods: {
        initResource() {
            this.resource = window._.cloneDeep(this.value);
            const occupation_skills_goals = window._.cloneDeep(this.value.occupation_skills_goals);
            const admin_occupation_skills_goals = window._.cloneDeep(this.value.admin_occupation_skills_goals);
            this.resource.occupation_skills_goals = occupation_skills_goals.concat(admin_occupation_skills_goals);
        },

        loadDefaultWishlist() {
            ratingService.getRatingsByStatus({
                employee_id: this.value.employee.id,
                statuses: [-1, 0, 1], // Not in 2, 3
                perpage: 1,
                orderBy: "rating_date",
                direction: "desc",
                include: ['wishlistJobs', 'wishlistOccupations']
            })
                .then(response => {

                    if (response.data && response.data.length > 0) {
                        const lastRating = response.data[0];

                        this.resource.wishlist_jobs = lastRating.wishlist_jobs;
                        this.resource.wishlist_occupations = lastRating.wishlist_occupations;
                    }
                })
        },

        async loadReferentialOccupations() {
            return window
                .axios({
                    method: "get",
                    url: "/api/referentiel/occupations/referential",
                    params: {
                        perpage: 9999,
                        include: [
                            "sector",
                            "admin_occupation_skills"
                        ]
                    }
                })
                .then(response => {
                    let referentialOccupations = response.data.data
                    this.referentialOccupations.data = referentialOccupations;
                    this.referentialOccupations.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        async loadThemes() {
            this.themes.loading = true;

            return window
                .axios({
                    method: "get",
                    url: `/api/gestion/employees/-1/ratings/goals/themes`,
                    params: {}
                })
                .then(response => {
                    this.themes.data = response.data;
                    this.themes.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        /**
         * Chargement des zones de commentaires paramétrées sur la base client
         */
        loadRatingFields() {
            return window
                .axios({
                    method: "get",
                    url: "/api/referentiel/rating-fields",
                    params: {
                        perpage: 9999,
                        include: []
                    }
                })
                .then(response => {

                    // Init de la resource
                    if (!this.resource.comment || Object.values(this.resource.comment).length == 0) {
                        response.data.forEach(item => {
                            if (!this.resource.comment[item.name]) {
                                this.resource.comment[item.name] = '';
                            }
                        })
                    }

                    this.ratingFields = response.data.sort((a, b) => (a.order > b.order ? 1 : -1));
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        inputHandle(val) {
            
            let data = window._.cloneDeep(this.value);
            data.wishlist_jobs = val.wishlist_jobs;
            data.wishlist_occupations = val.wishlist_occupations;
            data.occupation_skills_goals = val.occupation_skills_goals;
            data.admin_occupation_skills_goals = [];
            data.skills_goals = val.skills_goals;
            data.others_goals = val.others_goals;
            data.comment = val.comment;

            this.$emit('input', data);
        },
        inputHandleComment(value, fieldName) {

            // const value = event.selection.root.innerHTML;
            this.$set(this.resource.comment, fieldName, value);

            //Force emit here (never go in watch actually) because of the quill editor
            let data = window._.cloneDeep(this.value);
            data.comment = this.resource.comment;

            this.$emit('input', data);
        },
        getRatingLevelLabel(skill) {
            return this.ratingSettings.params[skill.level || 1]?.label || ''
        }
    }
};
</script>
<style scoped></style>
